import React from 'react';
import LanguageTag from '../Tags/LanguageTag';

export default function AppCard(props) {
	// console.log('AppCard', props);
	return (
		<div className="AppCard bg-gray-100 md:mx-4 min-w-80 my-4 p-7 rounded-md shadow-md">
			<div className="block" />
			<a href={props.data.url} target="blank">
				<h2 className="text-sm md:text-lg inline text-blue-500 hover:underline">
					<strong>{props.data.name}</strong>
				</h2>
				<i
					className="ml-2 fa-solid fa-arrow-up-right-from-square text-blue-500"
					aria-hidden="true"
				/>
			</a>
			<p className="my-3">{props.data.summary}</p>
			<hr className="my-5" />
			{props.data.languages.map((language) => (
				<LanguageTag language={language} key={language} />
			))}
		</div>
	);
}
